import type { FC } from 'react';
import { Button, ConfirmationModal, ModalBody, ModalFooter } from '@george-labs.com/design-system';
import { useEffect } from 'react';

import { t } from '@luna/i18n';
import { useNotifications } from '@shared/snackbar';

import { useImageUploadContext } from '../ImageUploadContext';
import { ImageUploadModal } from '../ImageUploadService';

type Props = {
    showResultAsNotification?: boolean;
};
export const ImageRemoveSuccessModal: FC<Props> = ({ showResultAsNotification }) => {
    const { currentModal, closeModal } = useImageUploadContext();
    const { displaySuccess } = useNotifications('image-remove');

    useEffect(() => {
        if (currentModal === ImageUploadModal.RemoveSuccessModal && showResultAsNotification) {
            closeModal();
            displaySuccess(t('main.imageUpload.successRemoveModalBody'));
        }
    }, [currentModal]);

    if (currentModal !== ImageUploadModal.RemoveSuccessModal) {
        return null;
    }

    return (
        <ConfirmationModal
            isOpen
            appear
            title={t('main.imageUpload.successRemoveModalTitle')}
            onClose={closeModal}
            data-cy="image-removal-success"
        >
            <ModalBody>{t('main.imageUpload.successRemoveModalBody')}</ModalBody>
            <ModalFooter>
                <Button onClick={closeModal}>{t('app.close')}</Button>
            </ModalFooter>
        </ConfirmationModal>
    );
};
